import React from 'react';
import { useInView } from '../hooks/useInView';
import { useEnroll } from '../context/EnrollContext';
import styles from './FinalCTA.module.css';

export default function FinalCTA() {
  const [ref, inView] = useInView();
  const { open } = useEnroll();

  return (
    <section className={styles.section}>
      <div className={styles.orb1} />
      <div className={styles.orb2} />
      <div className={`${styles.inner} ${inView ? styles.visible : ''}`} ref={ref}>
        <span className={styles.eyebrow}> Limited Seats Available</span>
        <h2 className={styles.title}>
          Ready to run ads that<br />actually work?
        </h2>
        <p className={styles.sub}>
          The next batch is filling up. Book a free 20-minute counselling call
          — zero commitment, zero pressure.
        </p>
        <div className={styles.actions}>
          <a href="#" className={styles.btnPrimary} onClick={e => { e.preventDefault(); open(); }}>
            Reserve My Seat Now →
          </a>
          <a
            href="https://wa.me/917387136569?text=Hi%20Digimint%2C%20I%27m%20interested%20in%20joining%20the%20Performance%20Marketing%20Course.%20Please%20share%20more%20details."
            className={styles.btnWhatsApp}
            target="_blank"
            rel="noopener noreferrer"
          >
             Chat on WhatsApp
          </a>
        </div>
        <p className={styles.footnote}>
          Questions? Email us at{' '}
          <a href="mailto:skills@digimintweb.in">skills@digimintweb.in</a>
          {' '}· We reply within 4 hours.
        </p>
      </div>
    </section>
  );
}
